import { TFunction } from 'react-i18next';

const getFormGenderOptions = (tForm: TFunction) => [
  { label: tForm('gender_m'), value: 'M' },
  { label: tForm('gender_f'), value: 'F' },
];

export default getFormGenderOptions;
